import React, { createContext, useContext, ReactNode } from 'react';
import { useInputTextArea } from '../hooks/useInputTextArea';

interface InputContextType {
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
  updateHandleSubmitInTextArea: (newHandleSubmit: (e: React.FormEvent) => void) => void;
  restoreInput: (content: string) => void;
  focusInput: () => void;
  resetHistory: () => void;
  checkMobile: () => void;
  textareaProps: any;
  internalRef: (el: HTMLTextAreaElement | null) => void;
  handleUndo: () => void;
  handleRedo: () => void;
}

const InputContext = createContext<InputContextType | undefined>(undefined);

export const InputContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {
    input,
    setInput,
    updateHandleSubmitInTextArea,
    restoreInput,
    focusInput,
    resetHistory,
    checkMobile,
    textareaProps,
    internalRef,
    handleUndo,
    handleRedo,
  } = useInputTextArea();

  return (
    <InputContext.Provider
      value={{
        input,
        setInput,
        updateHandleSubmitInTextArea,
        restoreInput,
        focusInput,
        resetHistory,
        checkMobile,
        textareaProps,
        internalRef,
        handleUndo,
        handleRedo,
      }}
    >
      {children}
    </InputContext.Provider>
  );
};

export const useInputContext = (): InputContextType => {
  const context = useContext(InputContext);
  if (!context) {
    throw new Error('useInputContext must be used within an InputContextProvider');
  }
  return context;
};
